import { warn } from '@execonline-inc/logging';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import ShareUrlStore from '.';
import { callApi } from '../../../../../../../../../../Appy';
import { findLinkT } from '../../../../../../../../../../LinkyLinky';
import ReactionComponent, { RCProps } from '../../../../../../../../../../ReactionComponent';
import { Link } from '../../../../../../../../../../Resource/Types';
import { programFamilyShareUrlResourceDecoder } from '../../../../../../../../Decoders';
import { ShareUrlError, State } from './Types';

interface Props extends RCProps<ShareUrlStore> {
  store: ShareUrlStore;
}

interface ShareUrlOut {
  id: number;
}

const shareUrlDeactivateEncoder = (id: number): ShareUrlOut => ({
  id,
});

const handleReportsError = (store: ShareUrlStore) => (error: ShareUrlError) => {
  store.error(error);
  warn('ShareUrlReactions', error.kind, error);
};

const linkRel = (kind: 'deactivating' | 'activating'): 'deactivate' | 'reactivate' => {
  switch (kind) {
    case 'activating':
      return 'reactivate';
    case 'deactivating':
      return 'deactivate';
  }
};

class ShareUrlReactions extends ReactionComponent<ShareUrlStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'ready':
        break;
      case 'deactivating':
      case 'activating':
        const { shareUrlResource } = state;
        Task.succeed<ShareUrlError, ReadonlyArray<Link>>(shareUrlResource.links)
          .andThen(findLinkT(linkRel(state.kind)))
          .andThen(
            callApi(
              programFamilyShareUrlResourceDecoder,
              shareUrlDeactivateEncoder(shareUrlResource.payload.id),
            ),
          )
          .fork(handleReportsError(store), store.ready);
        break;
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default ShareUrlReactions;
